import { takeLatest, call, put } from 'redux-saga/effects';
import get from 'lodash/get';
import { getVisitStoreToPurchaseByUrl } from 'yoda-interfaces/lib/Pdp/VisitStoreToPurchaseApi';
import {
    VISITSTORETOPURCHASE_GET_ERROR,
    VISITSTORETOPURCHASE_GET_REQUEST,
    VISITSTORETOPURCHASE_GET_SUCCESS,
    SET_SERVICE_ERROR,
    CLEAR_SERVICE_ERROR,
} from '../actionTypes/VisitStoreToPurchaseActionTypes';

function* VisitStoreToPurchaseSaga(payload) {
    try {
        const latLong = {
            lat: get(payload, 'visitStoreToPurchase.lat'),
            lng: get(payload, 'visitStoreToPurchase.lng'),
        };
        let userLatLong = '';
        const zipCode = get(payload, 'visitStoreToPurchase.zipCode');
        let coords;
        if (zipCode) {
            if (!__SERVER__) {
                coords = `location=${zipCode}`;
            }
        } else if (latLong.lat && latLong.lng) {
            coords = `latitude=${latLong.lat}&longitude=${latLong.lng}`;
            userLatLong = `${latLong.lat},${latLong.lng}`;
        }

        const vStoreToPurchase = yield call(
            getVisitStoreToPurchaseByUrl,
            get(payload, 'visitStoreToPurchase'),
            coords
        );
        if (vStoreToPurchase) {
            yield put({ type: CLEAR_SERVICE_ERROR });
        } else {
            yield put({ type: SET_SERVICE_ERROR });
        }
        const vStoreData = {
            ...vStoreToPurchase,
            userLatLong,
            zipCode,
            miles: get(payload, 'visitStoreToPurchase.miles'),
            isLoading: false,
            showAvailable: get(payload, 'visitStoreToPurchase.showAvailable'),
        };

        yield put({ type: VISITSTORETOPURCHASE_GET_SUCCESS, vStoreToPurchase: vStoreData });
    } catch (error) {
        yield put({ type: VISITSTORETOPURCHASE_GET_ERROR, error });
    }
}

const watchVisitStoreToPurchseSaga = function* watchVisitStoreToPurchseSaga() {
    yield takeLatest(VISITSTORETOPURCHASE_GET_REQUEST, VisitStoreToPurchaseSaga);
};

watchVisitStoreToPurchseSaga.sagaName = 'visitStoreToPurchseSaga';
export default watchVisitStoreToPurchseSaga;
